import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 35805 28648"
    {...props}
  >
    <defs>
      <style>
        {
          // ".str0,.str1{stroke:#1c1b17;stroke-width:518.912}.fil0{fill:none}.fil1{fill:#1c1b17}"
        }
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528313135472">
        <path
          d="M16410 23027h2985v2228c3809 135 6694 779 6694 1554 0 872-3665 1580-8187 1580-4521 0-8187-708-8187-1580 0-775 2886-1419 6695-1554v-2228zM32152 3652H3653v13572h28499V3652zM259 259h35287v21715H259V259z"
          className="stroke1 fill-none"
          style={{
            strokeWidth: 518.912,
          }}
        />
        <circle
          cx={31140}
          cy={20320}
          r={908}
          className="stroke1 fill"
          style={{
            strokeWidth: 518.912,
          }}
        />
        <circle
          cx={26989}
          cy={20320}
          r={908}
          className="stroke1 fill"
          style={{
            strokeWidth: 518.912,
          }}
        />
        <circle
          cx={22838}
          cy={20320}
          r={908}
          className="stroke1 fill"
          style={{
            strokeWidth: 518.912,
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
